import { InputAdornment, Typography } from "@mui/material";
import * as React from "react";
import { asWatt, phasedLimit } from "../../scripts/utils";

function formatPhasedLimit(limit, connectionType) {
  if (isNaN(limit) || limit === null) {
    return "No limit per phase";
  }
  const val = phasedLimit(limit, connectionType);
  return `~ ${asWatt(val)}W / phase`;
}

export function LimitAdornment({ limit, connectionType }) {
  return (
    <InputAdornment sx={{ ml: 1 }}>
      <Typography color="#BBB" fontSize={13} noWrap>
        {formatPhasedLimit(limit, connectionType)}
      </Typography>
    </InputAdornment>
  );
}
